// extracted by mini-css-extract-plugin
module.exports = {"tageaHeadline":"headline_tageaHeadline__u4HVB","xs":"headline_xs__ijXTl","sm":"headline_sm__FTTKe","md":"headline_md__x49AX","lg":"headline_lg__SPPyu"};